export const MANUFACTURER_FORM_ID = 'manufacturer-form';
